import { useState } from "react";
import { formatLabel } from "../../../../../../helper/helperFunction";

// Same range the report sends when the filter is left untouched
export const FULL_RANGE = [0, 100];

const useTypeRageSelect = ({ label, updateCourseState }) => {
  const [ageRange, setAgeRange] = useState(FULL_RANGE);
  const modifiedLabel = label && formatLabel(label);

  const handleAgeChange = (event, newAgeRange) => {
    setAgeRange(newAgeRange);
    updateCourseState({
      [modifiedLabel]: {
        min: newAgeRange[0],
        max: newAgeRange[1],
      },
    });
  };

  const handleDeleteChip = () => {
    setAgeRange(FULL_RANGE);
    updateCourseState({
      [modifiedLabel]: {
        min: FULL_RANGE[0],
        max: FULL_RANGE[1],
      },
    });
  };

  return { handleDeleteChip, handleAgeChange, ageRange };
};

export default useTypeRageSelect;
